<template>
  <div :class="{ hidden: hidden }" class="pagination-container">
    <el-pagination :background="background" :current-page.sync="currentPage" :page-size.sync="pageSize" :layout="layout"
      :page-sizes="pageSizes" :total="total" v-bind="$attrs" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" />
  </div>
</template>

<script>
import { scrollTo } from "./scrollTo";

export default {
  name: "Pagination",
  props: {
    total: {
      required: true,
      type: Number
    },
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 20
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 30, 50];
      }
    },
    layout: {
      type: String,
      default: "total, sizes, prev, pager, next, jumper"
    },
    background: {
      type: Boolean,
      default: true
    },
    autoScroll: {
      type: Boolean,
      default: true
    },
    hidden: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentPage: {
      get() {
        return this.page;
      },
      set(val) {
        this.$emit("update:page", val);
      }
    },
    pageSize: {
      get() {
        return this.limit;
      },
      set(val) {
        this.$emit("update:limit", val);
      }
    }
  },
  methods: {
    handleSizeChange(val) {
      this.currentPage = 1
      this.$emit("update:page", 1);
      this.$emit("pagination", { page: this.currentPage, limit: val });
      if (this.autoScroll) {
        scrollTo(0, 800);
      }
    },
    handleCurrentChange(val) { 
      this.$emit("pagination", { page: val, limit: this.pageSize });
      if (this.autoScroll) {
        scrollTo(0, 800);
      }
    }
  }
};
</script>

<style scoped lang="less">
.pagination-container {
  background: #fff;
  padding: 32px 0 !important;
  display: flex;
  justify-content: flex-end;
  // width: 100%;
  // z-index: 2001;
  // position: absolute;
  // bottom: 9px;
  // right: 30px;
  & /deep/ .el-pagination {
    padding: 0 !important;
  }
  & /depp/ .selected {
    color: rgb(26, 123, 252) !important;
  }
}
.pagination-container.hidden {
  display: none;
}
& /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background: rgb(26, 123, 252);
}
& /deep/ .el-select-dropdown .el-popper:hover {
  border-color: rgb(26, 123, 252);
}

&/deep/ .el-select-dropdown__item.selected {
  color: #1a7bfc;
}
</style>
